import { Dropdown as _Dropdown } from './Dropdown';
import { DropdownItem } from './Dropdown.Item';
import { DropdownList } from './Dropdown.List';
export var Dropdown = Object.assign(_Dropdown, {
  Item: DropdownItem,
  List: DropdownList
});